import { insert, omit, isEmpty } from 'ramda';

import declint from 'utils/declint';
import {CONVERGENCE_SERVICES_LINK} from "../../constants";

/**
 * Проверяет наличие параметров в объекте.
 * Если есть параметр добовляет ссылку.
 * Сылки отрисовываются в нижней части блока;
 * -----------------------------------------
 * @param services - Объект с данными;
 * @return {Array} - Массив объектов для отрисовки ссылок;
 */
export const getServicesArrayLinks = (services) => {
  const servicesLinksArray = [];

  if (isEmpty(services)) return servicesLinksArray;

  if (services.connectedServicesCount) {
    servicesLinksArray.push({
      children: declint(services.connectedServicesCount, [
        '%s подключенная услуга',
        '%s подключенных услуги',
        '%s подключенных услуг',
      ]),
      href: CONVERGENCE_SERVICES_LINK,
    });
  }

  if (services.servicesCatalogLink) {
    servicesLinksArray.push({
      children: 'Каталог услуг',
      href: services.servicesCatalogLink,
    });
  }

  return servicesLinksArray;
};

/**
 * Устанавливает цвет колбасок для аккумуляторов;
 * ----------------------------------------------
 * @param accumulator - Объект аккумулятора;
 * @param progressBarLimits - Объект содержащий лимит по длинне колбасок аккумулятора;
 */
export const getProgressBarColor = (accumulator, progressBarLimits) => {
  const percent = accumulator.rest / accumulator.size * 100;

  return Object.keys(progressBarLimits).find((color) => {
    const { min, max } = progressBarLimits[color];
    if (percent <= max && percent >= min) return true;
    return false;
  });
};

/**
 * Определяет имя аккумулятора по значению в переменной unit;
 * ---------------------------------------------------------
 * @param unit - Строковая переменная содержит название аккумулятора;
 */
export const getAccumulatorName = ({ unit }) => {
  switch (unit) {
    case 'KBYTE':
      return 'Интернет';
    case 'SECONDS':
      return 'Звонки';
    case 'SMS':
      return 'Сообщения';
    default:
      return '?';
  }
};

/**
 * Подготавливает список аккумуляторов для отрисовки в контенте;
 * ------------------------------------------------------------
 * @param list - Первичный список аккумуляторов;
 */
export const getAccumulatorsList = (list) => {
  if (!list || !list.length) return list;

  const presentAccumulatorIndex = list.findIndex(({ presentType, isUnlimited, showAccumulators }) => (
    presentType === 'UNL_PRES' && isUnlimited && showAccumulators
  ));

  if (presentAccumulatorIndex === -1) return list;

  const newAccumulator = omit(['presentType', 'isUnlimited',
    'showAccumulators', 'unlimExpirationDate'], list[presentAccumulatorIndex]);
  return insert(presentAccumulatorIndex + 1, newAccumulator, list);
};
